import Component from './DownloadBiospecimenDropdown';
import createRenderer from './DownloadBiospecimenDropdown.relay';
export default createRenderer(Component);



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/modern_components/DownloadBiospecimenDropdown/index.js